import React from 'react';
import { CFBaseIconVariant } from '../utilities';
export const CFIconTabFind = {
    alias: 'tab-find',
    defaultTitle: 'TabFind',
    source: ({ Path }, { color, variant }) => variant === CFBaseIconVariant.FILLED ? (React.createElement(Path, { fill: 'transparent', stroke: color, strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 2.5, d: 'M9.775 17.275a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm11.95 4.451-6.63-6.63' })) : (React.createElement(Path, { fill: 'transparent', stroke: color, strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 1.5, d: 'M9.775 17.275a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm11.95 4.451-6.63-6.63' })),
};
